import { Box, IconButton, styled, Table, TableCell } from '@mui/material'

export const TableCelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'index',
})<{ index: number }>(({ index, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // justifyContent: 'space-between',
  backgroundColor:
    index % 2 === 0 ? `${theme.palette.neutral.black}05` : 'transparent',
  borderRadius: '8px',
  padding: '16px',
}))

export const ValueWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  position: 'relative',
  zIndex: 1,
  width: '100%',
  minWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '316px',
    minWidth: '316px',
    maxWidth: '316px',
  },
}))

export const HeaderCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  [theme.breakpoints.down('sm')]: {
    flex: 1,
  },
  [theme.breakpoints.up('sm')]: {
    flex: 1,
  },
}))

export const InfoTableCell = styled(TableCell)({
  padding: 0,
  border: 0,
})

export const InfoTableStyled = styled(Table)({
  borderCollapse: 'separate',
  borderSpacing: '0 10px',
  maxWidth: '100%',
})

export const IconButtonStyled = styled(IconButton)({
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
  },
})
